"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _ScopesContainer = _interopRequireDefault(require("crm_internal/containers/ScopesContainer"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var BETCallActivityTypesOptions = _interopRequireWildcard(require("crm_ui/constants/BETCallActivityTypesOptions"));

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _BETActivityTypeMapping = require("crm_ui/utils/BETActivityTypeMapping");

var BETActivityTypes = _interopRequireWildcard(require("crm_ui/constants/BETActivityTypes"));

var _CallOutcomeDispositions = require("crm_data/constants/CallOutcomeDispositions");

var propTypes = {
  objectType: _ObjectTypesType.default.isRequired,
  onSave: _propTypes.default.func,
  onReset: _propTypes.default.func
};

var InteractionWithBETActivityTypes = function InteractionWithBETActivityTypes(InteractionComponent) {
  var InteractionWithBETActivityTypesComponent =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2.default)(InteractionWithBETActivityTypesComponent, _Component);

    function InteractionWithBETActivityTypesComponent() {
      var _this;

      (0, _classCallCheck2.default)(this, InteractionWithBETActivityTypesComponent);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InteractionWithBETActivityTypesComponent).call(this));
      (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
      _this.state = {
        selectedDisposition: '',
        selectedActivityType: undefined,
        selectedProduct: undefined,
        selectedFollowUpAction: undefined,
        selectedUnknownVisitorConversation: undefined
      };
      return _this;
    }

    (0, _createClass2.default)(InteractionWithBETActivityTypesComponent, [{
      key: "handleReset",
      value: function handleReset() {
        this.setState({
          selectedDisposition: '',
          selectedActivityType: undefined,
          selectedProduct: undefined,
          selectedFollowUpAction: undefined,
          selectedUnknownVisitorConversation: undefined
        });
      }
    }, {
      key: "handleSelectType",
      value: function handleSelectType(_ref) {
        var value = _ref.target.value;

        if ('object' === (0, _typeof2.default)(value)) {
          this.setState({
            selectedActivityType: value.activityType,
            selectedProduct: value.product,
            selectedFollowUpAction: value.followUpAction,
            selectedUnknownVisitorConversation: value.unknownVisitorConversation
          });
        } else {
          this.setState({
            selectedActivityType: value
          });
        }
      }
    }, {
      key: "handleDispositionChange",
      value: function handleDispositionChange(type, newDisposition) {
        if (type === _EngagementTypes.CALL) {
          if (newDisposition !== _CallOutcomeDispositions.CONNECTED) {
            this.handleReset();
          }

          this.setState({
            selectedDisposition: newDisposition
          });
        }
      }
    }, {
      key: "userIsIsc",
      value: function userIsIsc() {
        return _ScopesContainer.default.isScoped('bet-isc-log-activity-call-details');
      }
    }, {
      key: "callDetailsRequired",
      value: function callDetailsRequired() {
        return this.userIsIsc() && this.props.objectType === _ObjectTypes.CONTACT && this.state.selectedDisposition === _CallOutcomeDispositions.CONNECTED;
      }
    }, {
      key: "callDetailsSelected",
      value: function callDetailsSelected() {
        return !!this.state.selectedActivityType;
      }
    }, {
      key: "saveDisabled",
      value: function saveDisabled() {
        return this.callDetailsRequired() ? !this.callDetailsSelected() : false;
      }
    }, {
      key: "getSaveButtonTooltip",
      value: function getSaveButtonTooltip() {
        return this.saveDisabled() ? {
          title: _I18n.default.text('bet.openISCActivityTypeLog.tooltips.selectCallDetails')
        } : {
          open: false,
          disabled: true
        };
      }
    }, {
      key: "getCallSfdcValue",
      value: function getCallSfdcValue(selectedDisposition) {
        var value;

        if (this.state.selectedActivityType) {
          value = (0, _BETActivityTypeMapping.toSfdcValue)(this.state.selectedActivityType);
        } else if ([_CallOutcomeDispositions.NO_ANSWER, _CallOutcomeDispositions.BUSY, _CallOutcomeDispositions.WRONG_NUMBER].indexOf(selectedDisposition) > -1) {
          value = (0, _BETActivityTypeMapping.toSfdcValue)(BETActivityTypes.CALL_NO_VOICEMAIL);
        } else if ([_CallOutcomeDispositions.LEFT_LIVE_MESSAGE, _CallOutcomeDispositions.LEFT_VOICEMAIL].indexOf(selectedDisposition) > -1) {
          value = (0, _BETActivityTypeMapping.toSfdcValue)(BETActivityTypes.VOICEMAIL);
        }

        return value;
      }
    }, {
      key: "handleSave",
      value: function handleSave(interactionRecord, engagement, options) {
        var engagementToChange = engagement || interactionRecord.engagement;
        var selectedDisposition = interactionRecord.getIn(['metadata', 'disposition']);
        var type = interactionRecord.getIn(['engagement', 'type']) || engagement.get('type');
        var isTwilioCall = interactionRecord.hasIn(['metadata', 'externalAccountId']);
        var sfdcValue;

        if (type === _EngagementTypes.CALL) {
          sfdcValue = this.getCallSfdcValue(selectedDisposition, type);
        } else if (type === _EngagementTypes.EMAIL) {
          sfdcValue = (0, _BETActivityTypeMapping.toSfdcValue)(BETActivityTypes.EMAIL);
        }

        if (isTwilioCall) {
          options.activityType = sfdcValue;
          this.props.onSave(interactionRecord, engagement, options);
        } else {
          engagementToChange = engagementToChange.set('activityType', sfdcValue);

          if (this.state.selectedProduct) {
            engagementToChange = engagementToChange.set('productName', this.state.selectedProduct);
          }

          if (this.state.selectedFollowUpAction) {
            engagementToChange = engagementToChange.set('followUpAction', this.state.selectedFollowUpAction);
          }

          if (this.state.selectedUnknownVisitorConversation) {
            interactionRecord = interactionRecord.setIn(['metadata', 'unknownVisitorConversation'], this.state.selectedUnknownVisitorConversation);
          }

          this.props.onSave(interactionRecord.set('engagement', engagementToChange));
        }

        this.handleReset();
      }
    }, {
      key: "render",
      value: function render() {
        if (!_ScopesContainer.default.isScoped('bet-engagements-render-activity-type')) {
          return _react.default.createElement(InteractionComponent, this.props);
        }

        return _react.default.createElement(InteractionComponent, (0, _extends2.default)({}, this.props, {
          activityTypeOptions: BETCallActivityTypesOptions.byObjectType(this.props.objectType),
          onSave: this.handleSave,
          onSelectType: this.handleSelectType,
          BETselectedActivityType: this.state.selectedActivityType,
          onReset: this.handleReset,
          onDispositionChange: this.handleDispositionChange,
          saveDisabled: this.saveDisabled(),
          saveTooltip: this.getSaveButtonTooltip()
        }));
      }
    }]);
    return InteractionWithBETActivityTypesComponent;
  }(_react.Component);

  InteractionWithBETActivityTypesComponent.propTypes = propTypes;
  return InteractionWithBETActivityTypesComponent;
};

var _default = InteractionWithBETActivityTypes;
exports.default = _default;
module.exports = exports.default;